import { TODO_TAB } from '../constants'
import { HMPayState } from '../types'
import { FILTER_NAME } from './constants'

export const initialState: HMPayState = {
  error: undefined,
  isLoading: false,
  isLoadMoreUsed: false,
  isFailedToLoad: false,
  isOrderListPopulated: false,
  isKlarnaAuthRequested: false,
  isFetchingKlarnaProfile: false,
  loadingOrderId: '',
  operations: {},
  subscription: {},
  monthlyInvoices: {
    isLoading: false,
    error: false,
    invoices: {},
    filters: {
      [FILTER_NAME.ALL]: {
        expandedOrderId: null,
        expandedMonthlyInvoiceId: null,
        monthlyInvoiceIds: [],
      },
      [FILTER_NAME.TO_DO]: {
        expandedOrderId: null,
        expandedMonthlyInvoiceId: null,
        monthlyInvoiceIds: [],
      },
    },
  },
  selectedTab: TODO_TAB.id,
  orders: {
    invoices: {},
    filters: {
      [FILTER_NAME.ALL]: {
        nextOffset: 0,
        totalNumberOfOrders: 0,
        isLoading: false,
        isLoadingMore: false,
        isLoadMoreUsed: false,
        expandedOrderId: null,
        orderIds: [],
      },
      [FILTER_NAME.TO_DO]: {
        nextOffset: 0,
        totalNumberOfOrders: 0,
        isLoading: false,
        isLoadingMore: false,
        isLoadMoreUsed: false,
        expandedOrderId: null,
        orderIds: [],
      },
    },
  },
}

export default initialState
